import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/member-meetings`;

export const deleteMemberOnMeeting = async (meetingId) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${API_BASE_URL}/${meetingId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export const joinMemberOnMeeting = async (meetingId) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_BASE_URL}/${meetingId}`, null, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
};

export const getCheckedAndEvaluated = async (meetingId) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/check`, {
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: {
            meetingId
        }
    });
    return response.data;
};

export const checkAttendance = async (meetingId, latitude, longitude) => {
    const token = localStorage.getItem('token');
    const response = await axios.patch(`${API_BASE_URL}/check`, {
        meetingId,
        latitude,
        longitude
    }, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
};
